import { ContactFormType } from 'types';
import parse from 'html-react-parser';
import HubspotForm from 'react-hubspot-form';
import JotformEmbed from 'react-jotform-embed';
import { useContext } from 'react';
import {
  useNetlifyForm,
  NetlifyFormProvider,
  NetlifyFormComponent,
  Honeypot,
} from 'react-netlify-forms';
import { useForm } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ArtistContext } from 'context/ArtistContext';
import { InputTextarea } from 'primereact/inputtextarea';
import ReactGA from 'react-ga4';

interface ContactFormProps {
  contactFormData?: any;
}

export default function ContactFormSection({
  contactFormData,
}: ContactFormProps) {
  const artist = useContext(ArtistContext);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });
  const netlify = useNetlifyForm({
    name: 'Contact',
    action: '/contact',
    honeypotName: 'bot-field',
    onSuccess: (response: any, context: any) => {
      ('Successfully sent form data to LanzaMe Server');

      console.log('response', response);
      console.log('context', context);
      reset();
    },
  });

  const onSubmit = data => netlify.handleSubmit(null, data);

  const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i;

  if (!artist) return <div />;
  const { isSpanish } = artist;

  return (
    <div>
      {contactFormData.map((contactFormItem: ContactFormType) => (
        <section className="container grid mx-auto my-8 dark-section">
          <div className="col-12 md:col-10 mx-auto">
            <div
              className={`border-round p-2 mx-auto ${
                contactFormItem?.contactFormCssWrapper &&
                contactFormItem.contactFormCssWrapper
              }`}>
              {!!contactFormItem?.contactFormTitle && (
                <h2 className="text-2xl md:text-4xl xl:text-6xl text-center mb-0">
                  {parse(contactFormItem.contactFormTitle)}
                </h2>
              )}
              {!!contactFormItem?.contactFormDescription && (
                <div className="body-parsed-text text-center mx-auto w-10">
                  {parse(contactFormItem.contactFormDescription.html)}
                </div>
              )}
              {!!contactFormItem?.netlifyContactForm &&
                contactFormItem?.netlifyContactForm === true && (
                  <NetlifyFormProvider {...netlify}>
                    <NetlifyFormComponent onSubmit={handleSubmit(onSubmit)}>
                      <Honeypot />
                      <section className="container flex-column grid mx-auto dark-section">
                        <div className="col-10 md:col-8 mx-auto">
                          <div className="form-input-wrapper border-round p-4">
                            {netlify.success && (
                              <p>Thanks for contacting us!</p>
                            )}
                            {netlify.error && (
                              <p>
                                Sorry, we could not reach servers. Because it
                                only works on Netlify, our GitHub demo does not
                                provide a response.
                              </p>
                            )}
                            <div className="field-wrapper my-4">
                              <span className="p-float-label">
                                <InputText
                                  type="email"
                                  id="Email"
                                  className="w-full theme-border-primary"
                                  {...register('Email', {
                                    required: 'Email is required',
                                    pattern: {
                                      value: EMAIL_REGEX,
                                      message: 'Invalid email address',
                                    },
                                  })}
                                />
                                <label htmlFor="Email">
                                  {' '}
                                  {isSpanish ? 'Email' : 'Email'}
                                </label>
                              </span>
                              {errors.email && (
                                <div>{errors.email.message as string}</div>
                              )}
                            </div>

                            <div className="field-wrapper my-4">
                              <span className="p-float-label">
                                <InputText
                                  type="text"
                                  id="Name"
                                  className="w-full theme-border-primary"
                                  {...register('Name', {
                                    required: 'Name is required',
                                  })}
                                />
                                <label htmlFor="Name">
                                  {isSpanish ? 'Nombre' : 'Name'}
                                </label>
                              </span>
                              {errors.email && (
                                <div>{errors.email.message as string}</div>
                              )}
                            </div>

                            <div className="field-wrapper my-4">
                              <span className="p-float-label">
                                <InputText
                                  id="phone"
                                  className="w-full theme-border-primary"
                                  {...register('Phone', {
                                    required: 'Phone is required',
                                  })}
                                />
                                <label htmlFor="phone">
                                  {isSpanish ? 'Tel' : 'Phone'}
                                </label>
                              </span>
                            </div>

                            <div className="field-wrapper my-4">
                              <span className="p-float-label">
                                <InputTextarea
                                  id="Message"
                                  autoResize
                                  className="w-full theme-border-primary"
                                  rows={5}
                                  cols={30}
                                  {...register('Message', {
                                    required: 'Message is required',
                                  })}
                                />
                                <label htmlFor="Message">
                                  {isSpanish ? 'Mensaje' : 'Message'}
                                </label>
                              </span>
                              {/* {errors.email && <div>{errors.email.message}</div>} */}
                            </div>

                            <div>
                              <Button
                                type="submit"
                                onClick={() => {
                                  ReactGA.event({
                                    category: 'Interaction',
                                    action: `Contact Page - Form Submit`,
                                    label: `Contact Page - Form Submit`,
                                  });
                                }}
                                label={isSpanish ? 'Enviar' : 'Submit'}
                                className="p-button p-component theme-bg-white theme-border-blk border-1 px-4 md:px-8 py-3 theme-button mx-auto max-w-max block no-underline my-4 font-bold w-full"
                              />
                            </div>
                          </div>
                        </div>
                      </section>
                    </NetlifyFormComponent>
                  </NetlifyFormProvider>
                )}
              {!!contactFormItem?.hubspotFormId && (
                <HubspotForm
                  portalId={contactFormItem.hubspotPortalId}
                  formId={contactFormItem.hubspotFormId}
                  cssClass="block w-full mx-auto"
                  loading={<div />}
                />
              )}
              {!!contactFormItem?.jotformUrl && (
                <JotformEmbed src={contactFormItem?.jotformUrl} />
              )}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
